// extracted by mini-css-extract-plugin
module.exports = {"text":"mismatchTimezoneModal-module_text_966d9","footer":"mismatchTimezoneModal-module_footer_844cd","boldText":"mismatchTimezoneModal-module_boldText_8d3ee"};